import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import ButtonGroup from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/ButtonGroup';
import Button from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Button';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ClickAwayListener from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/ClickAwayListener';
import Paper from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Paper';
import Popper from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Popper';
import Grow from '@mui/material/Grow';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import { noop } from 'Helpers/PropTypes';

const styles = () => ({
  root: {},
  dropDownIcon: {},
  secondaryButton: {},
});

const ButtonGroupWithMenu = ({
  className,
  classes,
  color,
  text,
  onClick,
  options,
  variant,
  ButtonGroupProps,
  PopperProps,
  PrimaryButtonProps,
  SecondaryButtonProps,
}) => {
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);

  const handleToggle = (evt) => {
    evt.stopPropagation();
    evt.preventDefault();
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (evt) => {
    if (anchorRef.current && anchorRef.current.contains(evt.target)) {
      return;
    }

    setOpen(false);
  };

  return (
    <React.Fragment>
      <ButtonGroup
        className={classNames(classes.root, className)}
        variant={variant}
        color={color}
        ref={anchorRef}
        {...ButtonGroupProps}
      >
        <Button
          onClick={(evt) => {
            evt.stopPropagation();
            return onClick(evt);
          }}
          {...PrimaryButtonProps}
        >
          {text}
        </Button>
        <Button
          className={classes.secondaryButton}
          color={color}
          aria-haspopup="menu"
          onClick={handleToggle}
          {...SecondaryButtonProps}
        >
          <ArrowDropDownIcon
            className={classes.dropDownIcon}
          />
        </Button>
      </ButtonGroup>
      <Popper
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
        disableScrollLock
        {...PopperProps}
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
            }}
          >
            <Paper
              elevation={1}
            >
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList id="split-button-menu">
                  {options.map((option, index) => (
                    <MenuItem
                      key={option.id}
                      test={option.test}
                      onClick={(evt) => {
                        return option.onClick(evt, index);
                      }}
                    >
                      {option.label}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </React.Fragment>
  );
};

ButtonGroupWithMenu.defaultProps = {
  className: '',
  ButtonGroupProps: {},
  PopperProps: {},
  PrimaryButtonProps: {},
  SecondaryButtonProps: {},
  onClick: noop,
};

ButtonGroupWithMenu.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  ButtonGroupProps: PropTypes.object,
  PopperProps: PropTypes.object,
  PrimaryButtonProps: PropTypes.object,
  SecondaryButtonProps: PropTypes.object,
};

export default withStyles(styles)(ButtonGroupWithMenu);
